import { DockviewApi, IDockviewPanel } from 'dockview';
import { generateTabId } from '@/entities/tab/model/tab';
import { TabContext } from '@/entities/tab/model/tab.types';
import { getTabTitle } from '@/shared/config/route-core';
import { appendTabHistoryAtom } from '@/entities/tab/model/tab.atom';
import { useCallback } from 'react';
import { useSetAtom } from 'jotai';

export function useAddTab(api: DockviewApi | null) {
  const appendHistory = useSetAtom(appendTabHistoryAtom);

  const addTab = useCallback(
    (context: TabContext, overrideTitle?: string): IDockviewPanel | undefined => {
      if (!api) return;

      const tabId = context.tabId ? context.tabId : (context.tabId = generateTabId());

      const newContext: Required<TabContext> = {
        ...context,
        tabId,
      };

      appendHistory(newContext);

      const title = overrideTitle ? overrideTitle : getTabTitle(newContext);

      return api.addPanel({
        id: newContext.tabId,
        component: 'workspace',
        title: title,
        params: newContext,
      });
    },
    [api]
  );

  return { addTab };
}
